import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/smoothScroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Catalog } from "@/components/Catalog";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { KitSocial } from "@/components/KitSocial";

const HomePage = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Catalog />
      <Services />
      <WhyUs />
      <QuoteForm />
    </main>
    <Footer />
    <WhatsAppFloat />
  </>
);

function App() {
  useEffect(() => initLenis(), []);

  return (
    <div className="bg-[#181410] min-h-screen">
      <div className="pointer-events-none fixed inset-0 opacity-[0.035] mix-blend-overlay bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px] z-40" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/kit-social" element={<KitSocial />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: { background: "#2d261b", border: "1px solid rgba(212,163,89,0.3)", color: "#FBF9F5" },
        }}
      />
    </div>
  );
}

export default App;
